import styled from "styled-components";

export const RadioItem = styled('label')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  fontSize: '0.95rem',

  input: {
    appearance: 'none',
    width: '18px',
    height: '18px',
    border: `1.2px solid ${theme.CorporateTheme.colors.headerColor}`,
    borderRadius: '50px',
    position: 'relative',
    cursor: 'pointer',

    '&:checked::after': {
      content: '""',
      position: 'absolute',
      top: '4px',
      left: '6px',
      width: '4px',
      height: '8px',
      border: `solid ${theme.CorporateTheme.colors.headerColor}`,
      borderWidth: '0 3px 3px 0',
      transform: 'rotate(45deg)',
    },
  },
  span: {
    color: theme.CorporateTheme.colors.textSecondary,
  },
}));